import {html, LitElement} from "../libs/lit.dist.js";
export * from "../libs/lit.dist.js";
import {toSnakeCase} from "../util/string.js";

export const addStyle = css => {
    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
};

export const addScriptFile = src => {
    const script = document.createElement('script');
    script.src = src;
    document.body.appendChild(script)
};


let globalSheets = null;

export function getGlobalStyleSheets() {
    if (globalSheets === null) {
        globalSheets = Array.from(document.styleSheets)
            .map(x => {
                try {
                    const sheet = new CSSStyleSheet();
                    const css = Array.from(x.cssRules).map(rule => rule.cssText).join(' ');
                    sheet.replaceSync(css);
                    return sheet;
                } catch (e) {}
            })
            .filter(v => !!v);
    }

    return globalSheets;
}

export function addGlobalStylesToShadowRoot(shadowRoot) {
    shadowRoot.adoptedStyleSheets.push(
        ...getGlobalStyleSheets()
    );
}

export class PkLitElement extends LitElement {

    /**
     * Rejestruje klasę jako customElement pod nazwą z componentName
     * @see componentName
     */
    static registerComponent() {
        const componentName = this.componentName;
        if (!window.customElements.get(componentName)) {
            window.customElements.define(componentName, this);
        }
        return this;
    }

    /**
     * @return {string}
     */
    static get componentNamespace() {
        return 'pk';
    }

    /**
     * Nazwa elementu do użycia w HTML (np. klasa TestElement to 'pk-test-element', a w HTML <pk-test-element></pk-test-element>
     * @return {string}
     */
    static get componentName() {
        let name = toSnakeCase(this.name, '-');
        const namespace = this.componentNamespace + '-';
        if (name.indexOf(namespace) !== 0) {
            name = namespace + name;
        }
        return name;
    }

}

/**
 * Klasa prostego web elementu bez obsługi ShadowDom, ale z obsługą "slotów" poprzez metodę renderHTMLSlot oraz renderChildren
 */
export class WebElement extends PkLitElement {

    get useShadowRoot() {
        return false;
    }

    getHTMLSlotContent(name = '') {
        const slot = this.getHTMLSlot(name);
        return [...slot.childNodes].filter(node => node.nodeName !== '#comment' && (node.slot || '') === name);
    }

    getHTMLSlot(name = '') {
        return [...this.getElementsByTagName('slot')].filter(slot => slot.name || '' === name)[0] || this;
    }

    renderHTMLSlot(name = '') {
        return html`<slot name="${name}">${this.getHTMLSlotContent(name)}</slot>`;
    }

    renderChildren() {
        return this.renderHTMLSlot('');
    }

    createRenderRoot() {
        if (this.useShadowRoot) {
            return super.createRenderRoot();
        }
        return this;
    }

}

/**
 * @param {String} elementType
 * @param {Object} properties
 * @param {Object} options
 * @returns {*}
 */
export const createElementWithProperties = (elementType, properties = {}, options = {}) => {
    const element = document.createElement(elementType, options);
    for (let propertyName in properties) {
        element[propertyName] = properties[propertyName];
    }
    return element;
}
